export default __webpack_public_path__ + "media/images/temporary/pumpkin-patch-hero-a9da2dc32930c9185e0f10dda9a48713.jpg";